baseApp.directive('monitorStatistics', function() {
    return {
        templateUrl: '/public/directives/monitorStatistics.html',
        scope: {
            type: "=",
            finishedLoading: "=?",
            entityFilterOptions: "=?",
            monitorItems: "=?",
            options: "=?",
            tabFilter: "=",
            events: "@"
        },
        controller: ["$scope", "$interval", "$timeout", "$rootScope", "$filter", "$state", 'DateRangeService', function ($scope, $interval, $timeout, $rootScope, $filter, $state, DateRangeService) {

            /*
             Init
             */
            var DEFAULT_LINE_COLOR = "#FF6600";

            $scope.admin = $scope.options? !!$scope.options.admin : false;
            $scope.deviceId = $state.params.deviceId;
            $scope.single = $state.params.single;
            //$scope.selectedRow = $location.search().row;
            var destroy = false;


            filter();
            initDataCounters();

            const DISMISS_ANALYTICS_MODAL_KEY = "DismissAnalyticsModal";
            let dismissAnalyticsModal = window.localStorage.getItem(DISMISS_ANALYTICS_MODAL_KEY) && window.localStorage.getItem(DISMISS_ANALYTICS_MODAL_KEY) === "true";
            $scope.dismissModal = false;

            $scope.iteminfo = {};
            $scope.fulldata = [];
            $scope.olddata = [];
            $scope.realtimeDate = null;
            $scope.trafficData = [];

            $scope.graphinterval = 1000;
            $scope.legend = false;
            $scope.sitesRealtimeData = {};
            $scope.currentCatoEntityFilter = "all";
            $scope.posupdate = 0;
            $scope.isHostName = false;

            $scope.catoentitiesfilter = {
                field: "type",
                filterOptions: [{"id":"","name":"Sites & Users"},{"id":"SITE","name":"Sites"},{"id":"ACCESSLOGIN","name":"Users"}],
                selectedOption: ""
            };

            $scope.datamodified = false;

            $scope.piechartdataversion = 0;


            $scope.appsdata = [];
            $scope.domainsdata = [];
            $scope.hostsdata = [];
            $scope.currentItem = {};
            var searchTable = false;

            $scope.sitesData = {
                counters: []
            };
            $scope.usersData = {
                counters: []
            };

            var accountId = $state.params.accountId || "";
            if(accountId === ""){ // only for admin page
                $scope.isadmin = "admin";
                $scope.topnumber = 20;
            }
            else {
                $scope.topnumber = 5;
            }

            $scope.filtereddata = [];
            $scope.accountId = accountId;

            $scope.counters = [
                {name: 'Usage', unit: 'Bytes', label: 'Bytes Transferred', labelFunc: function(value){
                    return $filter('bytes')(value, 2);
                }, order: 1},
                {name: null, unit: '', label: '----------------', disabled: true, order: 5},
                {name: 'BytesReceived', unit: 'Bytes', label: 'Bytes Received', labelFunc: function(value){
                    return $filter('bytes')(value, 2);
                }, order: 6},
                {name: 'PacketsReceived', unit: 'Packets', label: 'Packets Received', order: 7},
                {name: 'BytesSent', unit: 'Bytes', label: 'Bytes Sent', labelFunc: function(value){
                    return $filter('bytes')(value, 2);
                }, order: 8},
                {name: 'PacketsSent', unit: 'Packets', label: 'Packets Sent', order: 9}
            ];

            $scope.loaders = {
                apps: false,
                domains: false,
                hosts: false,
                catoentities: false,
                traffic: false
            };

            function filter() {
                var monitoringFilter = $scope.tabFilter;
                if(monitoringFilter && (monitoringFilter.pid || monitoringFilter.pid == 0)){
                    if(($scope.type == 'logins' && monitoringFilter.type == 'site') || ($scope.type == 'sites' && monitoringFilter.type != 'site') ){
                        return;
                    }
                    if(!$scope.monitorItems){
                        $scope.monitorItems = {};
                    }
                    $scope.singlePid = true;
                    $scope.pid = monitoringFilter.pid;
                    $scope.pidtype = monitoringFilter.type + 's';
                    if($scope.entityFilterOptions){
                        $scope.entityFilterOptions.updateData = true;

                    }
                }
            }

            function savePreferenceToLocalStorage() {
                if ($scope.dismissModal) {
                    window.localStorage.setItem(DISMISS_ANALYTICS_MODAL_KEY, true);
                    dismissAnalyticsModal = true;
                }
            }

            $scope.switchToNewUi = function () {
                savePreferenceToLocalStorage();
                if ($rootScope.retireMonitorStats) {
                    $rootScope.saveChoiceAndJumpToAmazingUi();
                }
            }

            $scope.closeModal = function () {
                savePreferenceToLocalStorage();
                $rootScope.dismissNewUIModals($scope.type);
                $rootScope.closePopup("monitor-statistics-ui-switch-modal");
            }

            setWidgetTables();

            if (!dismissAnalyticsModal && !$rootScope.isNewUIModalDismissed($scope.type) && $rootScope.retireMonitorStats) {
                $rootScope.openPopup("monitor-statistics-ui-switch-modal");
            }


            function setWidgetTables(){
                $scope.appsfields = [
                    {"label": "Name", "path": "name", "template": "{{item.name || 'Unknown'}}"},
                    {"label": "Categories", "path": "category", "template": "{{(item.categoriesDisplay) || 'Unknown'}}"},
                    {"label": "Usage", "path": "size", "template": "{{item.size | bytes}} ({{item.percent | number:2}}%)"},
                    {"label": "Down", "path": "BytesReceived", "template": "{{item.BytesReceived | bytes}}"},
                    {"label": "Up", "path": "BytesSent", "template": "{{item.BytesSent | bytes}}"}
                ];

                if($scope.type === "sites"){
                    $scope.hostsfields = [
                        {"label": "Hostname", "path": "name", "template": "{{item.name || 'Unknown'}}"},
                        {"label": "Usage", "path": "size", "template": "{{item.size | bytes}} ({{item.percent | number:2}}%)"},
                        {"label": "Down", "path": "BytesReceived", "template": "{{item.BytesReceived | bytes}}"},
                        {"label": "Up", "path": "BytesSent", "template": "{{item.BytesSent | bytes}}"}
                    ];
                    if ($scope.$root.userAwareness) {
                        $scope.hostsfields = [
                            {"label": "User", "path": "logonName", "template": "{{item.logonName || 'N/A'}}"},
                            {"label": "Hostname", "path": "name", "template": "{{item.name || 'Unknown'}}"},
                            {"label": "Usage", "path": "size", "template": "{{item.size | bytes}} ({{item.percent | number:2}}%)"},
                            {"label": "Down", "path": "BytesReceived", "template": "{{item.BytesReceived | bytes}}"},
                            {"label": "Up", "path": "BytesSent", "template": "{{item.BytesSent | bytes}}"}
                        ];
                    }

                }
                else {
                    $scope.hostsfields = [
                        {"label": "IP", "path": "name", "template": "{{item.name || 'Unknown'}}"},
                        {"label": "Usage", "path": "size", "template": "{{item.size | bytes}} ({{item.percent | number:2}}%)"},
                        {"label": "Down", "path": "BytesReceived", "template": "{{item.BytesReceived | bytes}}"},
                        {"label": "Up", "path": "BytesSent", "template": "{{item.BytesSent | bytes}}"}
                    ];
                }

                $scope.hostsfields.splice(1, 0,  {"label": "Subnet", "path": "subnet", "template": "{{ item.subnet }}"});

                $scope.domainsfields = [
                    {"label": "Domain", "path": "tlDomain", "template": "{{item.tlDomain || item.domain  || item.wanIp || 'Direct IP'}}"},
                    {"label": "Application", "path": "appname", "template": "{{item.appname || 'Unknown'}}"},
                    {"label": "Categories", "path": "categoryName", "template": "{{item.categoryName | capitalize}}"},
                    {"label": "Usage", "path": "size", "template": "{{item.size | bytes}} ({{item.percent | number:2}}%)"},
                    {"label": "Down", "path": "BytesReceived", "template": "{{item.BytesReceived | bytes}}"},
                    {"label": "Up", "path": "BytesSent", "template": "{{item.BytesSent | bytes}}"}
                ];

                $scope.detaildomainsfields = [
                    {"label": "Domain", "path": "domain", "template": "{{item.domain || item.wanIp || 'Unknown'}}"},
                    {"label": "Application", "path": "appname", "template": "{{item.appname || 'Unknown'}}"},
                    {"label": "Categories", "path": "categoryName", "template": "{{item.categoryName | capitalize}}"},
                    {"label": "DNS", "path": "dns", "template": "{{item.dns || 'Unknown'}}"},
                    {"label": "HTTP host", "path": "host", "template": "{{item.httphost || 'Unknown'}}"},
                    {"label": "Usage", "path": "size", "template": "{{item.size | bytes}} ({{item.percent | number:2}}%)"},
                    {"label": "Down", "path": "BytesReceived", "template": "{{item.BytesReceived | bytes}}"},
                    {"label": "Up", "path": "BytesSent", "template": "{{item.BytesSent | bytes}}"}
                ];

                if($scope.isadmin){
                    $scope.detaildomainsfields.splice(5, 0, {"label": "Server port", "path": "port", "template": "{{item.serverport || 'Unknown'}}"});
                }

                $scope.domainclassificationfields = [
                    {"label": "Domain", "path": "domain", "template": "{{item.domain || 'Unknown'}}"},
                    {"label": "Category Names", "path": "categoryName", "template": "{{item.categoryName | capitalize}}"},
                    {"label": "Provider Name", "path": "provider", "template": "{{item.providerName}}"},
                    {"label": "Usage", "path": "size", "template": "{{item.size | bytes}} ({{item.percent | number:2}}%)"},
                    {"label": "Down", "path": "BytesReceived", "template": "{{item.BytesReceived | bytes}}"},
                    {"label": "Up", "path": "BytesSent", "template": "{{item.BytesSent | bytes}}"},
                    {"label": "Last Date", "path": "lastTimestamp", "template": "{{item.lastTimestamp | date:'yyyy-MM-dd'}}"},
                    {"label": "Updated Provider", "template": "{{item.updatedProvider}}","noSort":true},
                    {"label": "Updated Category", "template": "{{item.updatedCategoryName}}","noSort":true},
                    {"label": "classification Date", "template": "{{item.classificationTimestamp | date:'yyyy-MM-dd'}}","noSort":true}
                ];

                $scope.urlsdomainclassificationfields = [
                    {"label": "Domain", "path": "domain", "template": "{{item.domain || 'Unknown'}}"},
                    {"label": "Category Names", "path": "categoryName", "template": "{{item.categoryName | capitalize}}"},
                    {"label": "Usage", "path": "size", "template": "{{item.size | bytes}} ({{item.percent | number:2}}%)"},
                    {"label": "Down", "path": "BytesReceived", "template": "{{item.BytesReceived | bytes}}"},
                    {"label": "Up", "path": "BytesSent", "template": "{{item.BytesSent | bytes}}"},
                    {"label": "Last Date", "path": "lastTimestamp", "template": "{{item.lastTimestamp | date:'yyyy-MM-dd'}}"}
                ];

                $scope.catoentitiesfields = [
                    {"label": "Name", "path": "name", "template": "{{item.name || 'Unknown'}}"},
                    {"label": "Type", "path": "type", "template": "{{item.type === 'ACCESSLOGIN'? 'User' : 'Site'}}"},
                    {"label": "Usage", "path": "size", "template": "{{item.size | bytes}} ({{item.percent | number:2}}%)"},
                    {"label": "Down", "path": "BytesReceived", "template": "{{item.BytesReceived | bytes}}"},
                    {"label": "Up", "path": "BytesSent", "template": "{{item.BytesSent | bytes}}"}
                ];

                $scope.appclick = function (row) {
                    rowclick("app", row);
                };

                $scope.domainclick = function (row) {
                    rowclick("domain", row);
                };

                $scope.clientclick = function (row) {
                    rowclick("client", row);
                };

                $scope.domainclassificationclick = function (row) {
                    rowclick("domainclassification", row);
                };

                $scope.catoentityclick = function (row) {
                    rowclick("catoentity", row);
                };

                 //changes the title of Hosts / Users&Hosts according to User Awareness configuration
                $scope.getHostsTitleByUAConfiguration = function (){
                    var title = $scope.$root.userAwareness ? 'Users & Hosts' : 'Hosts';
                    return title;
                    }
    }

            function initDataCounters(){
                $scope.dataCounters = {
                    bytesTotal: 0,
                    bytesSent: 0,
                    bytesReceived: 0,
                    bytesDropped: 0,
                    packetsTotal: 0,
                    packetsSent: 0,
                    packetsReceived: 0,
                    packetsDropped: 0
                };
            }

            function setCatoEntitiesHostsTable(){
                $scope.catoentitieshoststable = {
                    fields: [
                        {"label": "IP", "path": "id", "template": "{{item.name || item.id}}"},
                        {"label": "Usage", "path": "size", "template": "{{item.size | bytes}} ({{item.percent | number:2}}%)"},
                        {"label": "Down", "path": "BytesReceived", "template": "{{item.BytesReceived | bytes}}"},
                        {"label": "Up", "path": "BytesSent", "template": "{{item.BytesSent | bytes}}"}
                    ],
                    showLoader: false,
                    defer: false,
                    noSearch: true,
                    expand: false,
                    hideFacets: true,
                    hideHead: false,
                    type: "clientIp",
                    dataURL: "innerTableDataURL",
                    expanderClick: true,
                    sortField: "size",
                    sortDir: "DESC",
                    parseData: "innerTableParseData",
                    innerLoader: true,
                    innerTableParseData: function(dataItems, type, parent){
                        var items = [];
                        dataItems.forEach(function(dataItem){
                            var tData = {};
                            tData.id = dataItem.id;
                            tData.name = (dataItem.hostname && dataItem.hostname !== "")? dataItem.hostname : dataItem.id;
                            tData.logonName = dataItem.logonName;
                            tData.subnet = dataItem.subnet;
                            tData.BytesSent = dataItem.counters.BytesSent;
                            tData.BytesReceived = dataItem.counters.BytesReceived;
                            tData.size = tData.BytesSent + tData.BytesReceived;
                            tData.percent = (tData.size / parent.size * 100);

                            items.push(tData);
                        });
                        return items;
                    },
                    innerTableDataURL: function(parent){
                        var fromDate = $scope.dateRange.from.getTime();
                        var toDate = $scope.dateRange.to.getTime();
                        var newInterval = $scope.statsInterval || 1000;

                        return "/getHostnamesTrafficDataUpdate?type="+ $scope.type + "_DRILLDOWN" + "&accountId=" + $scope.accountId +
                            "&fromDate=" + fromDate + "&toDate=" + toDate + "&interval=" + newInterval +
                            "&appid=" + ($scope.appid? $scope.appid : "") + "&tldomainid=" +($scope.tldomainid? $scope.tldomainid : "") + "&domainid=" +($scope.domainid? $scope.domainid : "") + "&wanIp=" +($scope.wanIp? $scope.wanIp : "") + "&clientid=&" +
                            "pid=" + parent.pid + "&domainCategoryId=" + (($scope.domainCategoryId || $scope.domainCategoryId == 0) ? $scope.domainCategoryId : "") + "&categoryId=" + ($scope.domainCategoryId? $scope.domainCategoryId : "") +"&tunnelHostName=" + (parent.type === 'SITE') + "&isCustomCategory=" + ($scope.isCustomCategory? $scope.isCustomCategory : "")
                            +"&domainClassificationId=" ;
                    }
                };

                $scope.catoentitieshoststable.fields.splice(1, 0,  {"label": "Subnet", "path": "subnet", "template": "{{item.subnet}}"});
                if ($scope.$root.userAwareness) {
                    $scope.catoentitieshoststable.fields.unshift({"label": "User", "path": "user", "template": "{{item.logonName || 'N/A'}}"});
                }
            }

            var mainTableFields = [];
            var tableType;
            var title;

            switch ($scope.type) {
                case "sites":
                    title = "Sites";
                    $scope.sitesData = {};
                    $scope.facets = [{"id": "type", order:1},{"id": "site_id", "ignoreFilter": true, label: "Client", "hide": true},{"id": "rt_site_id", "label": "Destination"},{"id": "appid", "label": "Destination"},
                        {"id": "action"},{"id": "documentGroupId", "ignoreFilter": true, "hide": true},{"id": "url_category", "label": "Destination"},{"id": "cats_unified_arr","label": "Destination"},{"id": "cats_custom_arr","label": "Destination"}];
                    if($scope.$root.userAwareness) {
                        $scope.facets.unshift({"id":"tunnel_host_netbios_name", "label":"Hosts"});
                        $scope.facets.unshift({"id":"tunnel_host_reverse_dns", "label":"Hosts"});
                        $scope.facets.unshift({"id":"tunnel_host_logon_names", "label":"Users"});
                    }
                    break;
                case "logins":
                    title = "Users";
                    $scope.usersData = {};
                    $scope.facets = [{"id": "type", order:1},{"id": "site_id", "ignoreFilter": true, label: "Client", "hide": true},{"id": "rt_site_id", "label": "Destination"},{"id": "appid", "label": "Destination"},
                        {"id": "action"},{"id": "documentGroupId", "ignoreFilter": true, "hide": true},{"id": "url_category", "label": "Destination"},{"id": "cats_unified_arr","label": "Destination"},{"id": "cats_custom_arr","label": "Destination"}];
                    break;
                case "apps":
                    title = "Apps";
                    tableType = "app";
                    setCatoEntitiesHostsTable();
                    $scope.facets = [{"id": "type", order:1},{"id": "site_id", label: "Client"},{"id": "appid", "ignoreFilter": true, "hide": true, "label": "appid"},
                        {"id": "action"},{"id": "documentGroupId", "ignoreFilter": true, "hide": true}];
                    mainTableFields = [
                        {"label": "Name", "path": "name", "template": "{{item.application.display_name}}"},
                        {"label": "Categories", "path": "category", "template": "{{item.application.categoriesDisplay}}"},
                        {"label": "Description", "path": "desc", "template": "{{item.application.desc}}"},
                        {"label": "Usage", "path": "size", "template": "{{item.counters.BytesReceived + item.counters.BytesSent | bytes}}"},
                        {"label": "Download", "path": "BytesReceived", "template": "{{item.counters.BytesReceived | bytes}}"},
                        {"label": "Upload", "path": "BytesSent", "template": "{{item.counters.BytesSent | bytes}}"}
                    ];
                    break;
                case "domains":
                    title = "Domains";
                    tableType = "domain";
                    setCatoEntitiesHostsTable();
                    mainTableFields = [
                        {"label": "Domain", "path": "tlDomain", "template": "{{item.tlDomain || item.domain || item.wanIp || 'Direct IP'}}"},
                        {"label": "Application", "path": "appname", "template": "{{item.appname || 'Unknown'}}","noSort":true},
                        {"label": "Categories", "path": "categoryName", "template": "{{item.categoryName.join(', ') | capitalize}}","noSort":true},
                        {"label": "Usage", "path": "size", "template": "{{item.counters.BytesReceived + item.counters.BytesSent | bytes}}"},
                        {"label": "Download", "path": "BytesReceived", "template": "{{item.counters.BytesReceived | bytes}}"},
                        {"label": "Upload", "path": "BytesSent", "template": "{{item.counters.BytesSent | bytes}}"}
                    ];
                    break;
                case "categories":
                    if ($state.current.unifiedCategories) {
                        title = "Categories";
                    } else {
                        title = "URL Categories";
                    }
                    tableType = 'categories';

                    $scope.facets = [{"id": "type", order:1},{"id": "site_id", label: "Client"}, {"id": "action"},{"id": "documentGroupId", "ignoreFilter": true, "hide": true},
                        {"id": "url_category", "ignoreFilter": true, "label": "category", hide: true}, {"id": "cats_unified_arr", "ignoreFilter": true,  "label": "category", hide: true}, {"id": "cats_custom_arr", "ignoreFilter": true,  "label": "category", hide: true}];

                    setCatoEntitiesHostsTable();
                    mainTableFields = [
                        {"label": "Category", "path": "name", "template": "{{(item.name | capitalize) || 'Unknown'}}"},
                        {"label": "Usage", "path": "size", "template": "{{item.counters.BytesReceived + item.counters.BytesSent | bytes}}"},
                        {"label": "Download", "path": "BytesReceived", "template": "{{item.counters.BytesReceived | bytes}}"},
                        {"label": "Upload", "path": "BytesSent", "template": "{{item.counters.BytesSent | bytes}}"}
                    ];
                    break;
                case "hosts":
                    title = $scope.getHostsTitleByUAConfiguration();
                    tableType = "clientIp";
                    mainTableFields = [
                        {"label": "IP/Hostname", "path": "id", "template": "{{item.hostname || item.id}}"},
                        {"label": "Usage", "path": "size", "template":"{{item.counters.BytesReceived + item.counters.BytesSent | bytes}}"},
                        {"label": "Down", "path": "BytesReceived", "template": "{{item.counters.BytesReceived | bytes}}"},
                        {"label": "Up", "path": "BytesSent", "template": "{{item.counters.BytesSent | bytes}}"}
                    ];
                    if ($scope.$root.userAwareness) {
                        mainTableFields.unshift({"label": "User", "path": "logonName", "template": "{{item.logonName || 'N/A'}}"});
                    }

                    mainTableFields.splice(1, 0,  {"label": "Subnet", "path": "subnet", "template": "{{item.subnet}}"});
                    break;
            }

            var MIN_STATS_INTERVAL = 5 * 60 * 1000; // 5 minutes
            var STATS_MIN_INTERVALS_COUNT = 500; // minimum number of intervals
            $scope.globalmin = $rootScope.dateRange.start;
            $scope.globalmax = $rootScope.dateRange.end;

            $scope.dateRange = DateRangeService.getNewRange();
            DateRangeService.initDateRange($scope.dateRange);

            $scope.netInterval = 0;

            $scope.showChart = true;
            if($scope.type == 'urlclassification'){
                $scope.showChart = false;
                $scope.piechartdataversion = new Date().getTime();
            }

           /* if($rootScope.showLoader && !$scope.showrates){
                $timeout(function(){
                    $rootScope.showLoader(pageId);
                }, 0);
            }*/

            $scope.currentcounter = $scope.counters[0];


            $scope.trafficDataCollection = store.addCollection({path: '/getTrafficData'});

            $scope.$watch('dateRange', function (newValue, oldValue) {
                if (newValue && oldValue && !_.isEqual(newValue, oldValue)) {
                    $scope.getTrafficDataByDates();
                    if ($scope.currentItem.type){
                        rowclick($scope.currentItem.type, $scope.currentItem, true);
                    }
                }
            }, true);

            /*
             End of Init
             */


            $scope.$watch('entityFilterOptions', function(newVal, oldVal){
                if($scope.entityFilterOptions && $scope.entityFilterOptions.updated){
                    $scope.entityFilterOptions.updated = false;
                }
            }, true);

            function updateFilters(){
                switch ($scope.type) {
                    case "sites":
                        $scope.filters = {
                            "Client": {
                                "label": "site_id",
                                "values": [$scope.pid]
                            }
                        };
                        break;
                    case "logins":
                        $scope.filters = {
                            "Client": {
                                "label": "site_id",
                                "values": [$scope.pid]
                            }
                        };
                        break;
                    case "apps":
                        if($scope.singlePid){
                            $scope.filters = {
                                "Application": {
                                    "label": "appid",
                                    "values": [$scope.appid]
                                },
                                "Client": {
                                    "label": "site_id",
                                    "values": [$scope.pid]
                                }
                            };
                        }
                        else {
                            $scope.filters = {
                                "Application": {
                                    "label": "appid",
                                    "values": [$scope.appid]
                                }
                            };
                        }

                        break;
                    case "categories":
                        if($scope.singlePid){
                            $scope.filters = {
                                "url_category": {
                                    "label": "category",
                                    "values": [$scope.domainCategoryId]
                                },
                                "cats_unified_arr": {
                                    "label": "category",
                                    "values":[$scope.domainCategoryId]
                                },
                                "cats_custom_arr": {
                                    "label": "category",
                                    "values":[$scope.domainCategoryId]
                                },
                                "Client": {
                                    "label": "site_id",
                                    "values": [$scope.pid]
                                }
                            };
                        }
                        else {
                            $scope.filters = {
                                "url_category": {
                                    "label": "category",
                                    "values": $scope.isCustomCategory === true ? [] :[$scope.domainCategoryId]
                                },
                                "cats_unified_arr": {
                                    "label": "category",
                                    "values": $scope.isCustomCategory === true ? [] :[$scope.domainCategoryId]
                                },
                                "cats_custom_arr": {
                                    "label": "category",
                                    "values": $scope.isCustomCategory === true ? [$scope.domainCategoryId] :[]
                                },
                                "url_exception_id" : {
                                    "label": "url_exception_id",
                                    "values": $scope.isCustomCategory === true ? [$scope.domainCategoryId] :[]
                                }
                            };
                        }

                        break;
                }
            }

            function updateSelectionForPies(appid, clientid, domainid, domainClassificationId, miniPid){
                $scope.selectedapp = "";
                $scope.selecteddomain = "";
                $scope.selecteddomainclassification = "";
                $scope.selectedclient = "";
                $scope.selectedentity = "";

                if(appid){
                    $scope.selectedapp = appid;
                }
                else if(domainid){
                    $scope.selecteddomain = domainid;
                }
                else if(domainClassificationId){
                    $scope.selecteddomainclassification = domainClassificationId;
                }
                else if(clientid){
                    $scope.selectedclient = clientid;
                }
                else if(miniPid || miniPid == 0){
                    $scope.selectedentity = miniPid;
                }
            }

            $scope.getTrafficDataByDates = function (noDefer, appid, clientid, tldomainid, domainid, wanIp, firstRun, filtered, domainCategoryId, domainClassificationId, miniPid, noDateUpdate, isHostName, onlyTraffic, isCustomCategory) {
                var path, fromDate, toDate, newInterval;

                if(destroy){
                    return;
                }
                $scope.loaders.traffic = true;

                if(!appid && !tldomainid && !domainid && !wanIp && !clientid && !domainClassificationId && !(miniPid || miniPid == 0)){
                    $scope.loaders.apps = true;
                    $scope.loaders.domains = true;
                    $scope.loaders.catoentities = true;
                    $scope.loaders.hosts = true;
                }

                var requestToDate;
                fromDate =  $scope.dateRange.from.getTime();
                fromDate = fromDate - (fromDate % MIN_STATS_INTERVAL);
                toDate = $scope.dateRange.to.getTime();
                if(toDate > new Date().getTime()){
                    requestToDate = new Date();
                    requestToDate.setSeconds(0);
                    requestToDate.setMilliseconds(0);
                    requestToDate = requestToDate.getTime();
                    requestToDate = requestToDate - (requestToDate % MIN_STATS_INTERVAL) + MIN_STATS_INTERVAL;
                }
                else {
                    requestToDate = toDate - (toDate % MIN_STATS_INTERVAL) + MIN_STATS_INTERVAL;
                }

                if(noDateUpdate || filtered){
                    if (DateRangeService.currentDateRangeRequested && DateRangeService.currentDateRangeRequested.toDate) {
                        requestToDate = DateRangeService.currentDateRangeRequested.toDate;
                    }
                }
                else {
                    // filtered requests requires the same date ranges of the original request, so we save the original request dates even beyond state changes
                    DateRangeService.currentDateRangeRequested = {fromDate: fromDate, toDate: requestToDate};

                    if (requestToDate && fromDate) {
                        newInterval = Math.floor((requestToDate - fromDate) / STATS_MIN_INTERVALS_COUNT);
                        if (newInterval > (2 * MIN_STATS_INTERVAL)) {
                            $scope.graphinterval = newInterval;
                        }
                        else {
                            $scope.graphinterval = MIN_STATS_INTERVAL;
                        }
                    }

                    $scope.statsInterval = newInterval || MIN_STATS_INTERVAL;
                    // if the state will change we don't want to fetch data as the directive will reload and fetch data again anyway
                    if (DateRangeService.zoomTo(fromDate, toDate, $scope.graphinterval || $scope.statsInterval)) {
                        return;
                    }
                }

                if (requestToDate) {
                    toDate = requestToDate;
                }

                var pid = "";
                var popId = null;
                if($scope.pid || $scope.pid == 0){
                    pid = $scope.pid;
                }

                path = "/getTrafficData";

                var requestId = 'monitor' + new Date().getTime();
                if((!appid && !tldomainid && !domainid && !wanIp && !clientid && !domainClassificationId && !(miniPid || miniPid == 0)) && $rootScope.showLoader){
                    updateSelectionForPies();
                }
                else {
                    updateSelectionForPies(appid, clientid, domainid, domainClassificationId, miniPid);
                }

                $scope.trafficDataCollection.fetch({
                    //showLoader: ((!appid && !domainid && !clientid && !domainClassificationId && !(miniPid || miniPid == 0)) && $rootScope.showLoader),
                    id: requestId,
                    defer: (!noDefer) ? 10 : null,
                    path: path,
                    filter: false,
                    queryParams: {
                        accountId: $state.params.accountId || "",
                        fromDate: fromDate,
                        toDate: toDate,
                        interval: $scope.graphinterval,
                        appid:  $scope.type === "apps"? ($scope.appid || "") : (appid || ""),
                        domainCategoryId: $scope.type === "categories"? ($scope.domainCategoryId || "") : (domainCategoryId || ""),
                        categoryId: $scope.type === "categories"? ($scope.domainCategoryId || "") : (domainCategoryId || ""),
                        domainClassificationId: domainClassificationId || "",
                        tldomainid: $scope.type === "domains"? ($scope.tldomainid || "") : (tldomainid || ""),
                        domainid: $scope.type === "domains"? ($scope.domainid || "") : (domainid || ""),
                        detailDomainid: $scope.type === "domains" ? (domainid || "") : "",
                        wanIp: $scope.type === "domains"? ($scope.wanIp || "") : (wanIp || ""),
                        clientid:  ((!$scope.isHostName && !isHostName) ? ($scope.hostid || clientid || "") : ""),
                        hostid: (($scope.isHostName || isHostName) ? ($scope.hostid || clientid || "") : ""),
                        type: $scope.type,
                        deviceId: $scope.deviceId || "",
                        pid: (miniPid || miniPid == 0)? miniPid : pid,
                        tunnelHostName: $scope.isHostName && ($scope.type === "sites" ||  $scope.type === "hosts"),
                        popId: popId,
                        onlyTraffic: onlyTraffic,
                        isCustomCategory: $scope.isCustomCategory
                    },
                    success: function (data) {
                        if(destroy){
                            return;
                        }
                        if (!filtered) {
                            $scope.piechartdataversion = new Date().getTime();
                        }

                        if (data && data.items) {
                            var trafficData;

                            if (filtered) {
                                $scope.filtereddata = processTraffic(data, pid);

                                $scope.loaders.traffic = false;
                                return;
                            }
                            trafficData = processData(data, (pid || pid == 0) && !firstRun);

                            $scope.fulldata = trafficData;
                            $scope.chartdata = $scope.fulldata;
                        }

                        if ((pid || pid == 0) || ($scope.type === "apps" && $scope.appid) || ($scope.type === "categories" && $scope.domainCategoryId) || ($scope.type === "domains" && $scope.tldomainid) || ($scope.type === "domains" && $scope.domainid) || ($scope.type === "domains" && $scope.wanIp) || ($scope.type === "hosts" && $scope.hostid)) {
                            updateFilters();
                        }
                        else {
                            $scope.iteminfo = {};
                        }

                        if (((!(pid || pid == 0) && !$scope.appid && !$scope.domainCategoryId  && !$scope.tldomainid && !$scope.domainid  && !$scope.wanIp && !$scope.hostid) || firstRun) && ($scope.type !== "main")) {
                            $scope.datamodified = new Date().getTime();
                        }

                        $scope.chartdata = $scope.fulldata;
                        $scope.loaders.traffic = false;
                        $scope.$digest();
                    }
                },true);
            };

            $scope.dataURL = function(){
                var fromDate = $scope.dateRange.from.getTime();
                var toDate = $scope.dateRange.to.getTime();
                var newInterval = $scope.statsInterval || 1000;

                var accountId = $state.params.accountId || "";
                var appid = $scope.type === "apps"? $scope.appid : "";
                var domainid = $scope.domainid || "";
                var tldomainid = $scope.tldomainid || "";
                var wanIp = $scope.wanIp || "";
                var detailDomainid = "";
                //var clientid = $scope.type === "hosts"? $scope.hostid : "";
                var clientid = ((!$scope.isHostName) ? ($scope.hostid || "") : "");
                var hostid = (($scope.isHostName) ? ($scope.hostid || "") : "");
                var tunnelHostName = $scope.type === "sites" || $scope.isHostName;
                var pid = ($scope.pid || $scope.pid == 0)? $scope.pid : "";
                var type;
                var domainCategoryId = ($scope.domainCategoryId || $scope.domainCategoryId == 0) ? $scope.domainCategoryId : "";
                var categoryId = domainCategoryId;
                var dataUrl = "/getTrafficDataUpdate";

                if(this && this.tableConfig){
                    if(this.tableConfig.type === "clientIp"){
                        dataUrl = "/getHostnamesTrafficDataUpdate";
                    }
                    else if(this.tableConfig.type === "catoEntities"){
                        dataUrl = "/getCatoEntitiesTrafficDataUpdate";
                    }
                }

                if (($scope.type === "urlclassification") && (this && this.tableConfig && this.tableConfig.type)) {
                    type = this.tableConfig.type;
                    dataUrl = "/getTrafficDataUpdate";
                }
                else {
                    type = $scope.type;
                }

                return dataUrl + "?type="+type+"&accountId=" + accountId+"&fromDate="+fromDate+"&toDate="+toDate+
                    "&interval="+newInterval+"&appid="+appid+"&tldomainid="+tldomainid+ "&domainid="+domainid+"&wanIp="+wanIp+ "&tunnelHostName="+tunnelHostName+
                    "&clientid="+clientid+"&hostid="+hostid+"&pid="+pid + "&domainCategoryId=" + domainCategoryId + "&categoryId=" + categoryId + "&detailDomainid=" + detailDomainid + "&domainClassificationId="  + "&isCustomCategory=" + ($scope.isCustomCategory? $scope.isCustomCategory : "");
            };

            function processData(data, skip) {

                var trafficData = processTraffic(data);

                setCounters(trafficData);

                if (data.sitesData.items) {
                    for (var dataItem in data.sitesData.items) {
                        processCounters(data.sitesData.items[dataItem].counters);
                    }

                    $scope.sitesData = data.sitesData;
                    $scope.sitesconnections = _.keys(data.sitesData.items).length;
                }

                if (data.usersData.items){
                    for (var dataItem2 in data.usersData.items) {
                        processCounters(data.usersData.items[dataItem2].counters);
                    }

                    $scope.usersData = data.usersData;
                    $scope.usersconnections = _.keys(data.usersData.items).length;
                }

                $scope.totalconnections = $scope.sitesconnections + $scope.usersconnections;

                return trafficData;
            }

            function setCounters(trafficData){
                initDataCounters();

                for (var i = 0; trafficData[i]; i++) {
                    trafficData[i].alphaField = 1;

                    if (trafficData[i].counters) {
                        $scope.dataCounters.bytesSent += trafficData[i].counters.BytesSent;
                        $scope.dataCounters.bytesReceived += trafficData[i].counters.BytesReceived;
                        $scope.dataCounters.packetsSent += trafficData[i].counters.PacketsSent;
                        $scope.dataCounters.packetsReceived += trafficData[i].counters.PacketsReceived;
                    }
                }

                $scope.dataCounters.packetsTotal = $scope.dataCounters.packetsReceived + $scope.dataCounters.packetsSent;
                $scope.dataCounters.bytesTotal = $scope.dataCounters.bytesSent + $scope.dataCounters.bytesReceived;
            }

            function processCounters(counters) {
                if (counters) {
                    counters.Usage = counters.BytesSent + counters.BytesReceived;
                }
            }

            function processTraffic(data) {
                var statsData = data.items;

                if (!statsData) {
                    return [];
                }

                var trafficData = $.map(statsData, function (value, index) {
                    return [value];
                });

                trafficData = _.sortBy(trafficData, 'dateTime');

                for (var i = 0; trafficData[i]; i++) {
                    trafficData[i].dateTime = new Date(trafficData[i].dateTime);
                    trafficData[i].lineColor = DEFAULT_LINE_COLOR;
                    trafficData[i].alphaField = 0.5;

                    if (trafficData[i].counters) {
                        processCounters(trafficData[i].counters);
                        if (trafficData[i].counters[$scope.currentcounter.name]) {
                            trafficData[i].size = trafficData[i].counters[$scope.currentcounter.name];
                            trafficData[i].label = (function(){
                                var currentIndex = i;
                                return function(){
                                    if($scope.currentcounter.unit === "Bytes"){
                                        return $filter('bytes')(trafficData[currentIndex].size,2);
                                    }
                                    else {
                                        return $filter('number')(trafficData[currentIndex].size,2) + " Packets";
                                    }
                                };
                            })();
                        }
                    }
                    else {
                        trafficData[i].size = 0;
                    }
                }

                return trafficData;
            }

            $scope.parseItems = function (dataItems, type) {
                var items = [];
                if(dataItems){
                    dataItems.forEach(function(dataItem){
                        var tData = {};
                        var name;

                        tData.BytesSent = dataItem.counters.BytesSent;
                        tData.BytesReceived = dataItem.counters.BytesReceived;
                        tData.PacketsSent = dataItem.counters.PacketsSent;
                        tData.PacketsReceived = dataItem.counters.PacketsReceived;
                        tData.size = tData.BytesSent + tData.BytesReceived;

                        if (type === "app") {
                            tData.id = dataItem.application.id;
                            tData.name = dataItem.application.display_name;
                            tData.categoriesDisplay = dataItem.application.categoriesDisplay;
                        }
                        else if (type === "domain" || type === "detaildomain") {
                            if(dataItem.tlDomain){

                            }
                            tData.id = dataItem.id;
                            tData.appname = dataItem.appname;
                            tData.tlDomain = dataItem.tlDomain;
                            tData.domain = dataItem.domain;
                            tData.wanIp = dataItem.wanIp;
                            tData.dns = dataItem.dns;
                            tData.httphost = dataItem.httphost;
                            tData.serverport = dataItem.serverport;
                            tData.categoryName = dataItem.categoryName ? dataItem.categoryName.join(', ') : "";
                            name = (type === "domain") ? (dataItem.tlDomain || dataItem.domain) : dataItem.domain;
                            tData.name = (dataItem.id !== "Others") ? name : "Others";
                            tData.lastTimestamp = dataItem.lastTimestamp;
                        }
                        else if (type === "domainClassification" || type === "domainTlClassification") {
                            tData.id = dataItem.id;
                            tData.categoryName = dataItem.categoryName ? dataItem.categoryName.join(', ') : "";
                            tData.domain = dataItem.domain;
                            tData.providerName = dataItem.providerName;
                            tData.updatedProvider = dataItem.updatedProvider;
                            tData.updatedCategoryName = dataItem.updatedCategoryName;
                            tData.classificationTimestamp = dataItem.classificationTimestamp;
                            name = dataItem.domain + ";" + dataItem.category;
                            tData.name = (dataItem.id !== "Others") ? name : "Others";
                            tData.lastTimestamp = dataItem.lastTimestamp;
                        }
                        else if(type === "catoEntities"){
                            tData.name = dataItem.name;
                            tData.id = dataItem.pid;
                            if(tData.name === "Others"){
                                tData.hide = true;
                                tData.id = "Others";
                            }
                            tData.type = dataItem.type;
                            tData.pid = dataItem.pid;
                            tData.subnet = dataItem.subnet;

                        }
                        else if(type === "clientIp"){
                            tData.name = (dataItem.hostname && dataItem.hostname !== "")? dataItem.hostname : dataItem.id;
                            tData.id = dataItem.id;
                            tData.isHostName = (dataItem.hostname && dataItem.hostname !== "") && !dataItem.isStaticHost;
                            tData.subnet = dataItem.subnet;
                            tData.logonName = dataItem.logonName;
                        }
                        else {
                            tData.name = dataItem.id;
                            tData.id = dataItem.id;
                        }

                        tData.percent = (tData.size / $scope.dataCounters.bytesTotal * 100);
                        if(tData.id === "Others"){
                            tData.hide = true;
                        }
                        items.push(tData);
                    });
                }
                return items;
            };


            // Main Table Config
            $scope.monitorConfig = {
                accountId: $state.params.accountId || "",
                innerLoader: true,
                dataURL: function () {
                    var accountId = $state.params.accountId || "";
                    var path, fromDate, toDate;

                    if(searchTable){
                        fromDate = $scope.dateRange.from ? $scope.dateRange.from.getTime() : $rootScope.dateRange.start;
                        toDate = $scope.dateRange.to ? $scope.dateRange.to.getTime() : $rootScope.dateRange.end;
                    }
                    else {
                        fromDate = $scope.dateRange.from ? $scope.dateRange.from.getTime() : $rootScope.dateRange.start;
                        fromDate = fromDate - (fromDate % MIN_STATS_INTERVAL);
                        toDate = $scope.dateRange.to ? $scope.dateRange.to.getTime() : $rootScope.dateRange.end;
                        if(toDate > new Date().getTime()){
                            toDate = new Date();
                            toDate.setSeconds(0);
                            toDate.setMilliseconds(0);
                            toDate = toDate.getTime();
                        }
                        else {
                            toDate = toDate - (toDate % MIN_STATS_INTERVAL);
                        }
                    }

                    var tunnelHostName = false;
                    switch ($scope.type) {
                        case "apps":
                            path = "/getStatsTable?type=APPS_MAP&accountId=" + accountId;
                            if($scope.singlePid){
                                path += "&pid=" + $scope.pid;
                            }
                            break;
                        case "categories":
                            path = "/getStatsTable?type=CATEGORIES_MAP&accountId=" + accountId;
                            if($scope.singlePid){
                                path += "&pid=" + $scope.pid;
                            }
                            break;
                        case "domains":
                            path = "/getStatsTable?type=DOMAINS_MAP&accountId=" + accountId;
                            if($scope.singlePid){
                                path += "&pid=" + $scope.pid;
                            }
                            break;
                        case "hosts":
                            path = "/getStatsTable?type=HOSTS_MAP&accountId=" + accountId;
                            if($scope.singlePid){
                                path += "&pid=" + $scope.pid;
                            }
                            tunnelHostName = true;
                            break;
                    }

                    path = path + "&fromDate=" + fromDate + "&toDate=" + toDate + "&interval="+(toDate-fromDate)+"&waitForAccount=true&dbFetch=true&getStats=dates&tunnelHostName=" + tunnelHostName;
                    searchTable = false;
                    return path;
                },
                processData: function(items,data) {
                    if (data.tooManyResults) {
                        $scope.$root.showNotification("error", "Partial results - Please select a smaller time range", "Partial results - Please select a smaller time range", true, false);
                    }
                    if (items) {
                        return items;
                    }
                },
                filter: false,
                fields: mainTableFields, // fields of table
                sortList : ($scope.type === "categories" || $scope.type === "apps" || $scope.type === "domains" || $scope.type === "hosts")? [{sortField: "size", sortDir: "DESC" }] : [{sortField: "rt_status", sortDir: "ASC" }],
                fixedLayout: true,
                //deselect: true,
                searchVal: $state.params.s,
                selectedId:  $state.params.pid,
                selectIdentifier: "protoId",
                type: tableType || null,
                pageSize: 5,
                hideCheckboxes: true,
                showOthers: false,
                titleSearch: title,
                onSearch: function(searchVal){
                    searchTable = true;
                },
                emptyTable: function(){
                    /*if($rootScope.showLoader && !searchTable){
                     $rootScope.hideLoader(this.requestId);
                     $rootScope.hideLoader(pageId);
                     }*/
                    searchTable = false;
                },
                onSelect: function(index, row){
                    $scope.isHostName = false;
                    $scope.appsdata = [];
                    $scope.hostsdata = [];
                    if (!row) {
                        /*if($rootScope.showLoader){
                         $rootScope.hideLoader(this.requestId);
                         }*/
                        $scope.getTrafficDataByDates();
                        return;
                    }

                    // compare clicked row to current row
                    if ((((row.id || row.id == 0) && row.id === $scope.iteminfo.id) || (row.application && row.application.id && $scope.iteminfo.application && row.application.id === $scope.iteminfo.application.id)) &&
                        (!row.deviceId || row.deviceId === $scope.iteminfo.deviceId)){
                        /*if($rootScope.showLoader){
                         $rootScope.hideLoader(pageId);
                         }*/

                        return;
                    }

                    $scope.iteminfo = row;

                    if($scope.iteminfo.deviceId){
                        $scope.deviceId = $scope.iteminfo.deviceId;
                    }

                    switch ($scope.type) {
                        case "domains":
                            if ($scope.iteminfo.tlDomain || $scope.iteminfo.tlDomain == ""){
                                $scope.tldomainid = $scope.iteminfo.id;
                                $scope.domainid = null;
                            }
                            else{
                                $scope.domainid = $scope.iteminfo.id;
                                $scope.tldomainid = null;
                            }
                            if ($scope.iteminfo.wanIp){
                                $scope.wanIp = $scope.iteminfo.wanIp;
                                $scope.domainid = null;
                                $scope.tldomainid = null;
                            }
                            break;
                        case "apps":
                            $scope.appid = $scope.iteminfo.application.id;
                            break;
                        case "categories":
                            $scope.domainCategoryId = $scope.iteminfo.id;
                            $scope.isCustomCategory = $scope.iteminfo.isUrlException ? $scope.iteminfo.isUrlException : "false";
                            break;
                        case "hosts":
                            if($scope.iteminfo.hostname && $scope.iteminfo.hostname != "" && !$scope.iteminfo.isStaticHost){
                                $scope.isHostName = true;
                            }
                            $scope.hostid = $scope.iteminfo.id;
                            break;
                        default:
                            if($scope.iteminfo.protoId || $scope.iteminfo.protoId == 0){
                                $scope.pid = $scope.iteminfo.protoId;
                            }
                            else {
                                $scope.pid = $scope.iteminfo.pid;
                            }
                            break;
                    }

                    $scope.getTrafficDataByDates();
                }
            };

            // Calling for get traffic if there is no main table (which usually calls for traffic data based on first item in table
            if($scope.single || $scope.type === "sites" || $scope.type === "logins"){
                $scope.getTrafficDataByDates();
            }

            /*
             Methods From View
             */
            $scope.changeCounter = function () {
                if($scope.currentcounter.name){
                    $scope.legend = false;
                    for (var i = 0; $scope.fulldata[i]; i++) {
                        if ($scope.fulldata[i].counters && $scope.fulldata[i].counters[$scope.currentcounter.name]) {
                            $scope.fulldata[i].size = $scope.fulldata[i].counters[$scope.currentcounter.name];
                        }
                        else {
                            $scope.fulldata[i].size = 0;
                        }
                        if($scope.filtereddata[i]){
                            if ($scope.filtereddata[i].counters && $scope.filtereddata[i].counters[$scope.currentcounter.name]) {
                                $scope.filtereddata[i].size = $scope.filtereddata[i].counters[$scope.currentcounter.name];
                            }
                            else {
                                $scope.filtereddata[i].size = 0;
                            }
                        }
                    }
                    $scope.chartdata = $scope.fulldata;
                }
            };

            $scope.openConnectivityChart = function (siteId) {
                return function () {
                    if($scope.type === "sites"){
                        $scope.siteid = siteId;
                    }
                    else {
                        $scope.loginid = siteId;
                    }
                };
            };



            $scope.changeCatoEntitiesFilter = function(){
                $scope.currentCatoEntityFilter = this.currentCatoEntityFilter;
            };
            /*
             End Methods From View
             */

            /*
             Children Events
             */
            function rowclick(type, row, ignoreSelection) {
                var id = (row.id || row.id == 0)? row.id : row.name;

                if (!ignoreSelection){
                    if(id === $scope.currentItem.id && type === $scope.currentItem.type){
                        $scope.filtereddata = [];
                        $scope.currentItem = {};
                        return;
                    }

                    if($scope.currentItem && type !== $scope.currentItem.type){
                        $scope.filtereddata = [];
                        $('#main-inner').find('.top-pie-charts .dashboard-tops:not(".dash-pie-' + type + '") .table-data tr').attr('selected', false);
                    }

                    $scope.currentItem = {
                        type: type,
                        id: id
                    };
                }

                switch (type) {
                    case "app" :
                        $scope.getTrafficDataByDates(null, id, null, null, null, row.wanIp, false, true, null, null, null, true, row.isHostName, true);
                        break;
                    case "client" :
                        $scope.getTrafficDataByDates(null, null, id, null, null, row.wanIp, false, true, null, null, null, true, row.isHostName, true);
                        break;
                    case "domain" :
                        if ((row.tlDomain || row.tlDomain == "") && !row.httphost && !row.dns && !row.serverport ){
                            $scope.getTrafficDataByDates(null, null, null, id, null, row.wanIp, false, true, null, null, null, true, row.isHostName, true);
                        }
                        else{
                            $scope.getTrafficDataByDates(null, null, null, null, id, row.wanIp, false, true, null, null, null, true, row.isHostName, true);
                        }
                        break;
                    case "domainclassification" :
                        $scope.getTrafficDataByDates(null, null, null, null, null, row.wanIp, false, true, null, id, null, true, row.isHostName, true);
                        break;
                    case "catoentity":
                        $scope.getTrafficDataByDates(null, null, null, null, null, row.wanIp, false, true, null, null, id, true, row.isHostName, true);
                        break;
                }
            }

            //Hiding loader after last stats widget in the page finished loading
            $scope.removeLoaderAfterUpdate = function(){
                /*if(!$rootScope.showLoader){
                    return;
                }

                switch (this.type){
                    case "clientIp":
                        if($scope.type === "sites" || $scope.type === "logins"){
                            $rootScope.hideLoader(pageId);
                        }
                        break;
                    case "catoEntities":
                        if($scope.type === "categories" || $scope.type === "apps" || $scope.type === "domains"){
                            $rootScope.hideLoader(pageId);
                        }
                        break;
                    case "domain":
                        if($scope.type === "hosts"){
                            $rootScope.hideLoader(pageId);
                        }
                        break;
                }*/
            };
            /*
             EndChildren Events
             */

            $scope.$on('$destroy', function () {
                destroy = true;
            });
        }]
    }
});
